module.exports = __webpack_public_path__ + "img/kc2.c128ae1a.png";